// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"c126cfb0","187":"aa4755d9","453":"8ab44547","805":"401bf7b9"}[chunkId] + ".chunk.js";
};